import {Mapper} from '@s-ui/domain'

export default class SearchRequestJSONToMotosParamsJSONMapper extends Mapper {
  constructor({config}) {
    super()
    this._config = config
    this._defaultSortBy = this._config.get('SORT_FIELDS').RELEVANCE
    this._defaultSortOrder = this._config.get('ORDER').DESC
    this._bodyTypeCategoryId = this._config.get('search').BODY_TYPE_CATEGORY
    this._sort = this._config.get('search').SORT
    this._unselectedOfferType = this._config.get('search').UNSELECTED_OFFER_TYPE
    this._listingSectionIds = this._config.get('COMMON').LISTING_SECTION_IDS
    this._offerTypeKm0 = this._config.get('search').OFFER_TYPE_KM0
    this._offerTypeSecondHand = this._config.get('search').OFFER_TYPE_SECOND_HAND
  }

  setParams = ({
    bodyTypeIds = [0],
    categoryId,
    category2Id = 0,
    filteredOfferTypeId,
    fuelTypeIds = [0],
    hasPhoto,
    hp = {},
    kms = {},
    listingSectionId,
    litres = {},
    location = {},
    makeId,
    model = {},
    offerTypeId,
    onlyPeninsula,
    page = 1,
    price = {},
    provinceIds = [0],
    searchText,
    sellerTypeId,
    sortBy = this._defaultSortBy,
    sortOrder = this._defaultSortOrder,
    vehicles = [],
    year = {}
  }) => {
    this._bodyTypeIds = bodyTypeIds
    this._categoryId = categoryId
    this._category2Id = category2Id
    this._filteredOfferTypeId = filteredOfferTypeId
    this._fuelTypeIds = fuelTypeIds
    this._hp = hp
    this._kms = kms
    this._listingSectionId = listingSectionId
    this._litres = litres
    this._makeId = makeId
    this._model = model
    this._page = page
    this._hasPhoto = hasPhoto
    this._location = location
    this._offerTypeId = offerTypeId
    this._onlyPeninsula = onlyPeninsula
    this._price = price
    this._provinceIds = provinceIds
    this._searchText = searchText
    this._sellerTypeId = sellerTypeId
    this._sortBy = this._sort[sortBy]?.queryParam
    this._sortOrder = sortOrder
    this._vehicles = vehicles
    this._year = year

    return this
  }

  map = () => ({
    arrProvince: this._parseArrayFilter(this._provinceIds),
    BodyTypeId: this.getBodyType() || undefined,
    fi: this._sortBy,
    FuelTypeId: this._fuelTypeIds[0] || undefined,
    locationDistance: this._location.radio || undefined,
    locationLat: this._location.lat || undefined,
    locationLong: this._location.long || undefined,
    locationText: this._location.text || undefined,
    locationProvinceId: this._location.provinceId || undefined,
    MaxKms: this._kms.to || undefined,
    MaxLitres: this._litres.to || undefined,
    MaxPrice: this._price.to || undefined,
    MaxYear: this._year.to || undefined,
    MinKms: this._kms.from || undefined,
    MinLitres: this._litres.from || undefined,
    MinPrice: this._price.from || undefined,
    MinYear: this._year.from || undefined,
    OfferType: this._getOfferType(),
    or: this.getSortDirection(),
    hasPhoto: this._hasPhoto,
    PowerHpFrom: this._hp.from || undefined,
    PowerHpTo: this._hp.to || undefined,
    onlyPeninsula: this._onlyPeninsula,
    pg: this._page,
    searchText: this._searchText || undefined,
    Section1Id: this._categoryId || undefined,
    Section2: this._category2Id || undefined,
    sellerType: this._sellerTypeId || undefined,
    ...this._getVehicleParams(this._vehicles)
  })

  _getVehicleParams = vehicles => {
    const queryParams = vehicles.reduce(
      (acc, {makeId, model = {}}) => {
        acc.MakeIds = [...acc.MakeIds, (makeId || this._makeId) ?? '0']
        acc.Models = [...acc.Models, (model.name || this._model.name) ?? '']
        return acc
      },
      {MakeIds: [], Models: []}
    )

    return queryParams
  }

  _getOfferType = () => {
    const defaultOfferType =
      this._listingSectionId === this._listingSectionIds.ALL_VEHICLES || this._offerTypeId === this._offerTypeKm0
        ? this._unselectedOfferType
        : this._offerTypeSecondHand

    const selectedValue =
      typeof this._filteredOfferTypeId === 'number' && this._filteredOfferTypeId !== defaultOfferType
        ? this._filteredOfferTypeId
        : undefined

    return selectedValue
  }

  /**
   * Avoid 0 values in URL
   * Array should appear as "pipe" separated strings in URL
   */
  _parseArrayFilter = (array = []) => {
    return array.filter(Boolean).length > 0 ? array.join('|') : undefined
  }

  /**
   * If value is 0 param should not exist, then there shouldn't appear in URL
   */
  _avoidDefaultValue = value => value || undefined

  getSortDirection = () => (this._sortOrder === this._defaultSortOrder ? -1 : 1)

  // The visual separators have value = -1. That's why we check makeId > 0
  getMakeId = () => (this._makeId > 0 ? this._makeId : undefined)

  getBodyType = () => (!this.hasBodyTypeCategoryBeenSelected(this._bodyTypeIds) ? this._bodyTypeIds[0] : undefined)

  /*
   ********** Details Implementation alert.
   * In the UI, the bodyTypeIds are shown as a dropdown which are grouped by a category.
   * These categories are: MOTORCYCLE, SCOOTER, ROAD and OFFROAD.
   * The user can select them too. In that case, the name of the query param is
   * Section2 instead of bodyTypeIds
   */
  hasBodyTypeCategoryBeenSelected = () =>
    this._bodyTypeIds.includes(this._bodyTypeCategoryId.MOTORCYCLE) ||
    this._bodyTypeIds.includes(this._bodyTypeCategoryId.SCOOTER) ||
    this._bodyTypeIds.includes(this._bodyTypeCategoryId.ROAD) ||
    this._bodyTypeIds.includes(this._bodyTypeCategoryId.OFFROAD)

  getVersion = () => this._keywords
}
